function isDummyKey(partitionListKey: string): boolean {
  let regexMatcher = /^dummyPartition/;
  return regexMatcher.test(partitionListKey);
}

export { isDummyKey };
